import { render } from "./popup-confirm.vue?vue&type=template&id=5bffc98c"
import script from "./popup-confirm.vue?vue&type=script&lang=js"
export * from "./popup-confirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__